'use strict';

var _ = require('lodash');
var SystemStatusFlightSentController = function SystemStatusFlightSentController($scope, systemStatusFlightRenderers, systemStatusCommonRendererFactory) {
  $scope.customRenderers = _.assign({}, systemStatusFlightRenderers, systemStatusCommonRendererFactory);
};
SystemStatusFlightSentController.$inject = ['$scope', 'SystemStatusFlightRenderersFactory', 'SystemStatusCommonRendererFactory', 'ConfigurationService'];
module.exports = SystemStatusFlightSentController;